"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mappers_1 = require("../mappers");
var createScreenloadEvent = function (event) {
    var pageloadData = {
        event: "screenload",
        eventInfo: "screenload",
        page: (0, mappers_1.mapPageData)(event.page),
        user: {
            loginStatus: event.loggedInUser ? 'logged-in' : 'logged-out',
        },
        pmistore: (0, mappers_1.mapStoreData)(event === null || event === void 0 ? void 0 : event.pmistore),
    };
    return pageloadData;
};
exports.default = createScreenloadEvent;
